/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RequestTypesEntrypointProps } from './RequestTypes.entrypoint.types.tsx';

type RequestTypesEntryPointComponent = EntryPointComponent<{}, {}, RequestTypesEntrypointProps, {}>;

export const requestTypesEntryPoint: EntryPoint<RequestTypesEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<RequestTypesEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-request-types" */ './RequestTypes.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
